<section class="add-product-variation-container">
  <div class="add-product-variation-header">
    <div class="title" [innerHTML]="'text_addProductOption' | dbText"></div>
    <div class="description" [innerHTML]="'text_sellDifferentVariations' | dbText"></div>
  </div>
  <db-product-variants [variantsForm]="variantsFormLocal"
                       [instantDelete]="true"
                       [showApply]="false"
                       (apply)="apply.emit(activeAttributes)"
                       [attributes]="atts"
                       [activeAttributes]="activeAttributes">
  </db-product-variants>
  <div class="actions-container">
    <a class="ds-btn-gray ds-btn-m" (click)="cancel()"><span>{{'text_cancel' | dbText}}</span></a>
    <a class="ds-btn-black ds-btn-m" (click)="add()"><span>{{ 'text_add' | dbText }}</span></a>
  </div>
</section>
